/*
 * Copyright 2026 Oddpods
 *
 * This Source Code Form is subject to the terms of the Mozilla Public
 * License, v. 2.0. If a copy of the MPL was not distributed with this
 * file, You can obtain one at https://mozilla.org/MPL/2.0/.
 *
 * See https://github.com/oddpods/cauce/blob/main/LICENSE
 */
package studio.oddpods.cauce.feature.dashboard

import androidx.navigation.NavController
import androidx.navigation.NavGraphBuilder
import androidx.navigation.NavOptions
import androidx.navigation.navigation
import kotlinx.serialization.Serializable
import studio.oddpods.cauce.core.base.ui.composableWithStayTransitions

@Serializable
data object DashboardDestination

@Serializable
data object DashboardRoute

fun NavController.navigateToDashboard(navOptions: NavOptions? = null) {
    navigate(DashboardDestination, navOptions)
}

@Suppress("UnusedParameter")
fun NavGraphBuilder.dashboardGraph(
    navController: NavController,
    onPatientClick: (String) -> Unit,
    onOpenReminders: () -> Unit = {},
) {
    navigation<DashboardDestination>(
        startDestination = DashboardRoute,
    ) {
        composableWithStayTransitions<DashboardRoute> {
            DashboardScreen(
                onPatientClick = onPatientClick,
                onOpenReminders = onOpenReminders,
            )
        }
    }
}
